import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import Counter from './counter';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuestionComponent } from './question/question.component';
import { QuestionoptionsComponent } from './questionoptions/questionoptions.component';
import { OptionComponent } from './option/option.component';
import { QuestionpageheaderComponent } from './questionpageheader/questionpageheader.component';
import { QuestionpagefooterComponent } from './questionpagefooter/questionpagefooter.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { UserexaminationsComponent } from './userexaminations/userexaminations.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { ToastrModule } from 'ngx-toastr';
import { AlertsInterceptor } from './interceptors/alerts.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthguardGuard } from './auth/authguard.guard';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { EssayComponent } from './essay/essay.component';
import { ExamLayoutComponent } from './exam-layout/exam-layout.component';
import { UserexaminationComponent } from './userexamination/userexamination.component';
import { QuestionlayoutComponent } from './questionlayout/questionlayout.component';
import { OptionCheckComponent } from './option-check/option-check.component';
import { SubmitComponent } from './submit/submit.component';
import { CountdownModule } from 'ngx-countdown';
import { LoadingSpinnerComponent } from './shared/loading-spinner/loading-spinner.component';
import { SubdomainInterceptor } from './interceptors/subdomain.interceptor';
import { RateLimitInterceptor } from './interceptors/rate-limit.interceptor';
import { CopypastecutDirective } from './copypastecut.directive';
import { CalculatorComponent } from './calculator/calculator/calculator.component';
import { IndexComponent } from './index/index.component';
import { ScientificcalcComponent } from './calculator/scientificcalc/scientificcalc.component';
import { ExamfeedbackComponent } from './examfeedback/examfeedback.component';
import { RegisterComponent } from './register/register.component';
import { P404Component } from './p404/p404.component';
import { DatePipe } from '@angular/common';
import { WebcamComponent } from './webcampassport/webcampassport.component';
import { SebinstructionpageComponent } from './sebinstructionpage/sebinstructionpage.component';
import { VerifyEmailComponent } from './register/verify-email/verify-email.component';
import { QuitSEBComponent } from './quit-seb/quit-seb.component';
import { LoadingEllipsesComponent } from './meeting/loading-ellipses/loading-ellipses.component';
import { MeetingChatComponent } from './meeting/meeting-chat/meeting-chat.component';
import { ParticipantAudioComponent } from './meeting/participant-audio/participant-audio.component';
import { ParticipantVideoComponent } from './meeting/participant-video/participant-video.component';
import { SelectMediaComponent } from './meeting/select-media/select-media.component';
import { MeetingComponent } from './meeting/meeting/meeting.component';
import { ParticipantsListComponent } from './meeting/participants-list/participants-list.component';
import { MainGroupListParticipantComponent } from './meeting/main-group-list-participant/main-group-list-participant.component';
import { ParticipantVideoSetupViewComponent } from './meeting/participant-video-setup-view/participant-video-setup-view.component';
import { FilterParticipantsPipe } from './meeting/services/filter-participants.pipe';
import { MinorGroupListParticipantComponent } from './meeting/minor-group-list-participant/minor-group-list-participant.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { ViewComplaintComponent } from './complaint/view-complaint/view-complaint.component';
import { AllComplaintComponent } from './complaint/all-complaint/all-complaint.component';
import { LanguageLayoutComponent } from './languages/language-layout/language-layout.component';
import { SystemCheckComponent } from './system-check/system-check.component';
import { SaqAnswerComponent } from './saq-answer/saq-answer.component';
import { ScientificCalcV2Component } from './calculator/scientific-calc-v2/scientific-calc-v2.component'
import { ScientificCalcV3Component } from './calculator/scientific-calc-v3/scientific-calc-v3.component';
import { QuillEditorComponent } from './quill-editor/quill-editor.component';
import { InstructionsModalComponent } from './shared/instructions-modal/instructions-modal.component';
import { QuestionlistComponent } from './questionlist/questionlist.component';
import { UnansweredQuestionsModalComponent } from './shared/unanswered-questions-modal/unanswered-questions-modal.component';
import { QuestionGroupComponent } from './question-group/question-group.component';
import { EssaySubquestionsComponent } from './essay-subquestions/essay-subquestions.component';
@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    QuestionComponent,
    QuestionoptionsComponent,
    OptionComponent,
    QuestionpageheaderComponent,
    QuestionpagefooterComponent,
    LoginComponent,
    UserexaminationsComponent,
    LogoutComponent,
    LoginLayoutComponent,
    EssayComponent,
    ExamLayoutComponent,
    UserexaminationComponent,
    QuestionlayoutComponent,
    OptionCheckComponent,
    SubmitComponent,
    LoadingSpinnerComponent,
    CopypastecutDirective,
    CalculatorComponent,
    IndexComponent,
    ScientificcalcComponent,
    ExamfeedbackComponent,
    RegisterComponent,
    P404Component,
    WebcamComponent,
    SebinstructionpageComponent,
    VerifyEmailComponent,
    QuitSEBComponent,
    LoadingEllipsesComponent,
    MeetingChatComponent,
    ParticipantAudioComponent,
    ParticipantVideoComponent,
    SelectMediaComponent,
    MeetingComponent,
    ParticipantsListComponent,
    MainGroupListParticipantComponent,
    ParticipantVideoSetupViewComponent,
    FilterParticipantsPipe,
    MinorGroupListParticipantComponent,
    ComplaintComponent,
    ViewComplaintComponent,
    AllComplaintComponent,
    LanguageLayoutComponent,
    SystemCheckComponent,
    SaqAnswerComponent,
    ScientificCalcV2Component,
    ScientificCalcV3Component,
    QuillEditorComponent,
    InstructionsModalComponent,
    QuestionlistComponent,
    UnansweredQuestionsModalComponent,
    QuestionGroupComponent,
    EssaySubquestionsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    CommonModule,
    CountdownModule,
    NgbModule,
    NgxPaginationModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      progressBar: true
    }),
    AppRoutingModule,
    DragDropModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RateLimitInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AlertsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubdomainInterceptor,
      multi: true,
    },
    AuthguardGuard,
    DatePipe,
  ],
})
export class AppModule { }
